module.exports = __webpack_public_path__ + "static/media/iosd_logo.ceb20747.png";